// components/shared/shops/ShopsList.tsx
"use client";

import { Shop } from "@cabukaka/types";
import { ShopCard } from "./ShopCard";
import { Store } from "lucide-react";

interface ShopsListProps {
    shops: Shop[];
    columns?: {
        mobile?: number;
        tablet?: number;
        desktop?: number;
    };
    showRating?: boolean;
    showLocation?: boolean;
}

export function ShopsList({ 
    shops, 
    columns = { mobile: 1, tablet: 2, desktop: 4 },
    showRating = true,
    showLocation = true
}: ShopsListProps) {
    const getGridCols = () => {
        const mobile = columns.mobile || 1;
        const tablet = columns.tablet || 2;
        const desktop = columns.desktop || 4;
        return `grid grid-cols-${mobile} sm:grid-cols-${tablet} lg:grid-cols-${desktop} gap-4 md:gap-6`;
    };

    if (shops.length === 0) {
        return (
            <div className="text-center py-12">
                <Store className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                <p className="text-gray-500">Aucune boutique trouvée</p>
            </div>
        );
    }

    return (
        <div className={getGridCols()}>
            {shops.map((shop) => (
                <ShopCard 
                    key={shop.id} 
                    shop={shop} 
                    showRating={showRating}
                    showLocation={showLocation}
                />
            ))}
        </div>
    );
}